import axios from 'axios';
import { loginreq, req } from './axiosFun';

//获取实时数据列表
export const getRealTimeData = (params) => { return req("get", "/api/meterData/getRealTimeData", params) };

//获取首页数据
export const findconutMeterInfo = (params) => { return req("get", "/api/index/findconutMeterInfo", params) };


//能耗日历
// export const findEnergyDay = (params) => { return req("get", "/api/index/findEnergyDay", params) };

//能耗日历
export const findEnergyDay = (params) => { return req("get", "/api/index/findEnergyDayNew", params) };

//能耗日历
export const findEnergyYtList = (params) => { return req("get", "/api/index/findEnergyYtList", params) };

//能耗分类
export const findEnergyBranchList = (params) => { return req("get", "/api/index/findEnergyBranchList", params) };

//生成日用量
export const energyDay = (params) => { return req("get", "/api/manual/energyDay", params) };


//生成月用量
export const energyMonth = (params) => { return req("get", "/api/manual/energyMonth", params) };


//生成每日能耗数据
export const saveDailyEnergyRecord = (params) => { return req("post", "/api/manual/saveDailyEnergyRecord", params) };


//生成每日能耗数据
export const flushRedis = (params) => { return req("post", "/api/manual/flushRedis", params) };


//重新存储某天的能耗日历与月历
export const redisEnergy = (params) => { return req("get", "/api/manual/redisEnergy", params) };


//获取水电表数据
export const getAllMeter = (params) => { return req("get", "/api/index/findconutMeterInfoByDepartment", params) };

//根据用户类型获取部门（预付费、非预付费）
export const getDeps = (params) => { return req("get", "/api/department/findDepartmentByAccountType", params) };


//异常数据（6个小时内没有采集到数据）
export const getUnusual = (params) => { return req("get", "/api/index/getAllUnUpdateMeterInfo", params) };

// 总充值金额
export const countMoney = (params) => { return req("get", "/api/index/countMoney", params) };


// 开户未开户数据
export const getMeterInfoData = (params) => { return req("get", "/api/index/getMeterInfoData", params) };

// 欠费数据
export const getQfRunning = (params) => { return req("get", "/api/index/getQfRunning", params) };


// 所有即将欠费表数据
export const getQFMeterInfoByDepartmentId = (params) => { return req("get", "/api/index/getQFMeterInfoByDepartmentId", params) };

// 获取终端数量
export const getTerminalCount = (params) => { return req("get", "/api/index/getTerminalCount", params) };

// 获取windows数据
export const getWindowsData = (params) => { return req("get", "/api/windowsData/getWindowsData", params) };

// 删除windows数据
export const deleteWindowsDataById = (params) => { return req("post", "/api/windowsData/deleteWindowsDataById", params) };

// 根据用户生成月账单
export const generateMonthlyBillByUser = (params) => { return req("post", "/api/monthlyBill/generateMonthlyBillByUser", params) };

// 手动执行将数据入es库
export const getPowerDataFromLocal = (params) => { return req("post", "/api/manual/getPowerDataFromLocal", params) };


export const initializeRoom = (params) => { return req("post", "/api/room/initializeRoom", params) };


export const compute = (params) => { return req("get", "/api/propertyPriceConfig/compute", params) };

export const callDateByTest = (params) => { return req("get", "/api/manual/callDateByTest", params) };

export const saveYearBill = (params) => { return req("get", "/api/manual/saveYearBill", params) };

export const findPayTypeById = (params) => { return req("get", "/api/department/findPayTypeById", params) };

export const uploadMeterRent = (params) => { return req("post", "/api/meterInfo/uploadMeterRent", params,true) };


export const addWalletRecharge = (params) => { return req("post", "/api/manual/addWalletRecharge", params) };


// WEBPACK FOOTER //
// ./src/api/dataMG.js